export const AIF_LOGIN = 'AIF_LOGIN'
export const AIF_LOGIN_RESPONSE = 'AIF_LOGIN_RESPONSE'
export const AIF_LOGIN_FAIL = 'AIF_LOGIN_FAIL'

export const RESET_FORGOT_PASSWORD_AIF = 'RESET_FORGOT_PASSWORD_AIF'
export const RESET_FORGOT_PASSWORD_AIF_RESPONSE = 'RESET_FORGOT_PASSWORD_AIF_RESPONSE'
export const RESET_FORGOT_PASSWORD_AIF_FAIL = 'RESET_FORGOT_PASSWORD_AIF_FAIL'